import { checkEnvironment } from '@saviynt/common';

const getFileDownloadApiUrl = (userName, attachmentKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/requests/attachment/${attachmentKey}?username=${userName}`;
};

export default getFileDownloadApiUrl;
